




















































import Vue from 'vue';

import Task from '@/models/soukai/Task';

import AppNavigationSidepanel from '@/components/AppNavigationSidepanel.vue';
import Freezable from '@/components/Freezable.vue';

import TaskPanelForm from './TaskPanelForm.vue';
import TaskPanelInfo from './TaskPanelInfo.vue';

export default Vue.extend({
    components: {
        AppNavigationSidepanel,
        Freezable,
        TaskPanelForm,
        TaskPanelInfo,
    },
    computed: {
        isOpen(): boolean {
            return this.$tasks.active !== null;
        },
        isClosed(): boolean {
            return !this.isOpen;
        },
    },
    methods: {
        close() {
            this.$tasks.setActive(null, false);
        },
        edit() {
            this.$tasks.setEditing(true);
        },
        remove() {
            this.$ui.openDialog(
                () => import('@/dialogs/RemoveTask.vue'),
                { task: this.$tasks.active },
            );
        },
    },
});
